import { AccountNav } from "./types";

const ChevronRightIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-6 shrink-0">
    <path d="M9 6L15 12L9 18" stroke="#898994" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MyAccountNav = ({ accountNavData }: { accountNavData: AccountNav[] }) => {
  const getMobileMenuSvg = (menuTitle: string) => {
    switch (menuTitle) {
      case "My Competitions":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 13L10.544 14.632C10.816 15.449 11.581 16 12.442 16H19C20.105 16 21 15.105 21 14V8.155C21 7.05 20.105 6.155 19 6.155H14.068"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 21L3.877 5.632C3.446 4.337 4.41 3 5.775 3H12.068C13.173 3 14.068 3.895 14.068 5V11C14.068 12.105 13.173 13 12.068 13H6.333"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "My Instant Wins":
      case "My Wins":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_my_wins)">
              <path
                d="M13 3V10H19L11 21V14H5L13 3Z"
                stroke="#898994"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_my_wins">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      case "My Fun Centre Wins":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14 11H19.5C20.3284 11 21 10.3284 21 9.5V8.5C21 7.67157 20.3284 7 19.5 7H4.5C3.67157 7 3 7.67157 3 8.5V9.5C3 10.3284 3.67157 11 4.5 11H10"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 11V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V11"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 3V3C11.1046 3 12 3.89543 12 5V7H10C8.89543 7 8 6.10457 8 5V5C8 3.89543 8.89543 3 10 3Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14 3V3C15.1046 3 16 3.89543 16 5V5C16 6.10457 15.1046 7 14 7H12V5C12 3.89543 12.8954 3 14 3Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              x="10"
              y="7"
              width="4"
              height="14"
              rx="1"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "My Free Tickets":
      case "My Wallet":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M19.7998 16.9905V18.1905C19.7998 18.827 19.547 19.4375 19.0969 19.8875C18.6468 20.3376 18.0363 20.5905 17.3999 20.5905H5.39998C4.76346 20.5905 4.15302 20.3376 3.70294 19.8875C3.25285 19.4375 3 18.827 3 18.1905V9.7906C3 9.15409 3.25285 8.54365 3.70294 8.09356C4.15302 7.64348 4.76346 7.39062 5.39998 7.39062H17.3999C18.0363 7.39062 18.6468 7.64348 19.0969 8.09356C19.547 8.54365 19.7998 9.15409 19.7998 9.7906V10.9906"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.3983 7.38999L15.5351 3.66363C15.4647 3.52261 15.3671 3.39686 15.248 3.29356C15.129 3.19025 14.9907 3.11143 14.8411 3.06158C14.6916 3.01173 14.5337 2.99183 14.3764 3.00303C14.2192 3.01422 14.0657 3.0563 13.9248 3.12683L5.39844 7.38999"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.7968 16.9902C20.1151 16.9902 20.4203 16.8638 20.6454 16.6387C20.8704 16.4137 20.9968 16.1084 20.9968 15.7902V12.1902C20.9968 11.872 20.8704 11.5667 20.6454 11.3417C20.4203 11.1166 20.1151 10.9902 19.7968 10.9902H16.7968C16.0012 10.9902 15.2381 11.3063 14.6755 11.8689C14.113 12.4315 13.7969 13.1945 13.7969 13.9902C13.7969 14.7859 14.113 15.5489 14.6755 16.1115C15.2381 16.6741 16.0012 16.9902 16.7968 16.9902H19.7968Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.8 14.2894C16.6343 14.2894 16.5 14.1551 16.5 13.9895C16.5 13.8238 16.6343 13.6895 16.8 13.6895"
              stroke="#898994"
              strokeWidth="1.5"
            />
            <path
              d="M16.7969 14.2894C16.9626 14.2894 17.0969 14.1551 17.0969 13.9895C17.0969 13.8238 16.9626 13.6895 16.7969 13.6895"
              stroke="#898994"
              strokeWidth="1.5"
            />
          </svg>
        );
      case "Game Credit":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="8.25" stroke="#898994" strokeWidth="1.5" />
            <path
              d="M14.7626 15.6887C14.315 15.8938 13.8285 16 13.3362 16C12.8439 16 12.3574 15.8938 11.9098 15.6887C11.4419 15.5272 10.9446 15.469 10.4521 15.5183C9.95963 15.5675 9.48367 15.723 9.05706 15.974C9.36254 15.8682 9.63184 15.6781 9.83378 15.4257C10.0357 15.1733 10.1621 14.8688 10.1982 14.5476V10.2685C10.2012 9.76861 10.3682 9.28358 10.6736 8.88786C10.979 8.49215 11.4058 8.20764 11.8886 8.07804C12.3714 7.94845 12.8833 7.98092 13.3458 8.17049C13.8083 8.36005 14.1958 8.69622 14.4488 9.12735M12.9939 12.5507H9"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "My Details":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6 18.584C7.569 17.059 9.692 16.121 12.023 16.121C14.331 16.121 16.431 17.04 18 18.537C16.431 20.062 14.308 21 11.977 21C9.669 21 7.569 20.081 6 18.584Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.975 16.025C3.365 14.811 3 13.452 3 12C3 7.026 7.026 3 12 3C16.974 3 21 7.026 21 12C21 13.45 20.637 14.81 20.023 16.023"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.1213 7.87868C15.2929 9.05025 15.2929 10.9497 14.1213 12.1213C12.9497 13.2929 11.0502 13.2929 9.87866 12.1213C8.70709 10.9497 8.70709 9.05025 9.87866 7.87868C11.0502 6.70711 12.9497 6.70711 14.1213 7.87868"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "Loyalty Club":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.0802 7.38881C11.2529 7.03862 11.6095 6.81689 12 6.81689C12.3905 6.81689 12.7471 7.03862 12.9199 7.38881L13.6702 8.90991C13.8196 9.2127 14.1084 9.42259 14.4425 9.47116L16.1208 9.71508C16.507 9.77122 16.828 10.0418 16.9487 10.413C17.0693 10.7842 16.9688 11.1918 16.6894 11.4643L15.4747 12.6491C15.2331 12.8847 15.1229 13.2241 15.18 13.5567L15.4667 15.2279C15.5326 15.6127 15.3745 16.0016 15.0587 16.2311C14.7429 16.4605 14.3241 16.4908 13.9786 16.3092L12.4772 15.5202C12.1784 15.3632 11.8216 15.3632 11.5228 15.5202L10.0214 16.3093C9.67587 16.4909 9.25715 16.4606 8.94133 16.2311C8.62551 16.0016 8.46736 15.6128 8.53337 15.228L8.82001 13.5567C8.87707 13.2241 8.76686 12.8847 8.52527 12.6491L7.31064 11.4643C7.0312 11.1918 6.9307 10.7842 7.05137 10.413C7.17205 10.0418 7.49298 9.77122 7.87927 9.71508L9.5575 9.47116C9.89163 9.42259 10.1804 9.2127 10.3298 8.90991L11.0802 7.38881Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.0327 9.06496L20.0291 9.39109"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.97099 14.6089L2.96729 14.935"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 21.4999V20.4443"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M12 2.5V3.55556" stroke="#898994" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
              d="M17.5784 19.678L16.9587 18.8249"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.42168 4.32197L7.04145 5.1751"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.96729 9.06496L3.97099 9.39109"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.0328 14.935L20.0291 14.6089"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.5784 4.32197L16.9587 5.1751"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.42168 19.678L7.04145 18.8249"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "Holiday Giveaway":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14 11H19.5C20.3284 11 21 10.3284 21 9.5V8.5C21 7.67157 20.3284 7 19.5 7H4.5C3.67157 7 3 7.67157 3 8.5V9.5C3 10.3284 3.67157 11 4.5 11H10"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 11V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V11"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 3V3C11.1046 3 12 3.89543 12 5V7H10C8.89543 7 8 6.10457 8 5V5C8 3.89543 8.89543 3 10 3Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14 3V3C15.1046 3 16 3.89543 16 5V5C16 6.10457 15.1046 7 14 7H12V5C12 3.89543 12.8954 3 14 3Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              x="10"
              y="7"
              width="4"
              height="14"
              rx="1"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  const navItems = accountNavData?.filter(navItem => !navItem.IsAlternateMainNav) ?? [];
  const sectionTitles = accountNavData?.filter(nonNavItem => nonNavItem.IsAlternateMainNav) ?? [];

  if (!sectionTitles.length && !navItems.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 w-full min-w-0">
      {sectionTitles.map((nonNavitem, index) => (
        <button
          type="button"
          key={index}
          className="text-xs font-jost font-medium leading-4 uppercase text-gray-1 text-left cursor-pointer"
          onClick={() => {
            location.href = nonNavitem.Url;
          }}>
          {nonNavitem.Title}
        </button>
      ))}
      {navItems.length > 0 && (
        <ul className="flex flex-col w-full bg-white rounded-lg overflow-hidden">
          {navItems.map((navItem, index) => {
            const isLast = index === navItems.length - 1;

            return (
              <li key={navItem.Title || index} className="w-full">
                <button
                  type="button"
                  onClick={() => {
                    location.href = navItem.Url;
                  }}
                  className="flex items-center w-full h-14 px-4 gap-4 bg-white cursor-pointer text-left">
                  <div className="relative flex items-center justify-center size-6 shrink-0 overflow-clip">
                    {getMobileMenuSvg(navItem.Title)}
                  </div>
                  <div
                    className={`flex flex-1 items-center min-w-0 h-14 gap-2 ${
                      isLast ? "" : "border-b border-solid border-black/8"
                    }`}>
                    <span className="flex-1 min-w-0 text-base font-roboto font-normal leading-5.5 text-secondary break-words">
                      {navItem.Title}
                    </span>
                    <ChevronRightIcon />
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default MyAccountNav;
